import { use, useEffect, useEffectEvent } from 'react';

import { ChatContext } from '../contexts/ChatContext';
import type { ChatProviderMessage } from '../types';

export function useOnMessage(callback: (message: ChatProviderMessage, messages: ChatProviderMessage[]) => void) {
  const { onMessage } = use(ChatContext);
  const eventCallback = useEffectEvent(callback);

  useEffect(() => {
    // console.debug('Ssubscribe onMessage');
    const unsubscribe = onMessage(eventCallback);
    return () => {
      // console.debug('Unsubscribe onMessage');
      return unsubscribe();
    };
  }, [onMessage]);
}
